import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class JsonLdService {
  private renderer: Renderer2;
  private data: any[] = []; // Alle JSON-LD Objekte
  private scriptId = 'structured-data-script';

  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /** Füge neue JSON-LD Daten hinzu (z. B. von Blog- oder Review-Komponente) */
  addData(item: any): void {
    this.data.push(item);
    this.updateScript();
  }

  /** Entferne JSON-LD wieder (optional, falls Komponente zerstört wird) */
  removeDataByName(name: string): void {
    this.data = this.data.filter(d => d.name !== name);
    this.updateScript();
  }

  /** Script im DOM aktualisieren oder erstellen */
  private updateScript(): void {
    // Script prüfen oder erstellen
    let script = this.document.getElementById(this.scriptId);
    if (!script) {
      script = this.renderer.createElement('script');
      // @ts-ignore
      script.setAttribute('type', 'application/ld+json');
      // @ts-ignore
      script.setAttribute('id', this.scriptId);
      this.renderer.appendChild(this.document.head, script);
    }

    // --- 🔧 Zusammenführen in EIN gemeinsames @graph-Objekt ---
    let mergedData: any = {
      "@context": "https://schema.org",
      "@graph": []
    };

    // Hilfsfunktion: rekursiv alle Objekte aus verschachtelten @graph extrahieren
    const flattenGraph = (item: any): any[] => {
      if (!item) return [];
      if (Array.isArray(item)) return item.flatMap(i => flattenGraph(i));
      if (item["@graph"]) return flattenGraph(item["@graph"]);
      const copy = { ...item };
      delete copy["@context"]; // lokale @context entfernen
      return [copy];
    };

    if (Array.isArray(this.data)) {
      this.data.forEach(obj => {
        mergedData["@graph"].push(...flattenGraph(obj));
      });
    } else if (typeof this.data === 'object' && this.data !== null) {
      mergedData["@graph"].push(...flattenGraph(this.data));
    } else {
      console.warn('Keine gültigen JSON-LD-Daten zum Rendern.');
      return;
    }

    // --- 🧹 Bereinigung: Duplikate per @id entfernen ---
    const unique = new Map<string, any>();
    mergedData["@graph"].forEach((obj: any) => {
      const key = obj["@id"] || JSON.stringify(obj);
      unique.set(key, obj);
    });
    mergedData["@graph"] = Array.from(unique.values());

    // --- 🖋️ In Script schreiben ---
    // @ts-ignore
    script.textContent = JSON.stringify(mergedData, null, 2);
  }


}
